import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ContactListsContact from "./ContactListsContact";
import type CoreVersion from "./CoreVersion";
import type Organisation from "./Organisation";
import type User from "./User";

enum ExternalType {
  "c3" = "c3",
  "mygorkana" = "mygorkana",
  "ngc3" = "ngc3",
  "outreach_v1" = "outreach_v1",
}

@Model()
class ContactList extends ApplicationRecord {
  static jsonapiType = "contact_lists";

  @Attr() archivedAt: string;

  @HasMany() contactListsContacts: ContactListsContact[];

  @Attr({ persist: false }) contactListsContactsCount: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr() description: string;

  @Attr() externalId: string;

  @Attr() externalType: ExternalType;

  @Attr() latestVersion: CoreVersion;

  @Attr({ persist: false }) mediaReleasesContactListsCount: number;

  @Attr() name: string;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() organisationTeamId: number;

  @Attr({ persist: false }) pitchesContactListsCount: number;

  @Attr() private: boolean;

  @Attr({ persist: false }) reindexingAt: string;

  @HasMany({ name: "taggable" }) tags: any[];

  @Attr({ persist: false }) updatedAt: string;

  @BelongsTo() updatedByUser: User;

  @Attr() updatedByUserId: number;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default ContactList;
